<template>
  <!-- 企业供应商组下拉嵌套选择 -->
  <tree-select
    v-model="treeCopyIds"
    style="display: inline-block"
    class="tree-select"
    :placeholder="placeholder"
    :options="categoryTreeList"
    :normalizer="normalizer"
    :value-format="valueFormat"
    :multiple="multiple"
    append-to-body
    no-options-text="暂无数据"
    no-results-text="暂无数据"
    clear-value-text="清空选项"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
// 组件
import TreeSelect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

// api接口
import { getSupplierLibSortApi } from '@/api/supplier-management/supplier-lib'

// 工具
import { listTransformTree } from '@/utils/utils'

export default {
  name: 'CompanyCategoriesSelect',

  components: {
    TreeSelect
  },

  model: {
    prop: 'treeIds',
    event: 'change'
  },

  props: {
    treeIds: {
      type: [String, Number, Array, Object],
      default: ''
    },
    // "id" or "object"
    valueFormat: {
      type: String,
      default: 'id'
    },
    placeholder: {
      type: String,
      default: '请选择分组'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * 初始加载组件是否需要获取数据
     */
    needInit: {
      type: Boolean,
      default: true
    },
    /**
     * 禁止选择项
     */
    disabledList: {
      type: Array,
      default: () => []
    },

    /**
     * 是否默认选中第一个
     */
    isCheckFirst: {
      type: Boolean,
      default: false
    },

    /**
     * 目前更换分组专用；招募审核使用
     * 实现需求，默认选中第一项（全部供应商分组）且不可操作
     */
    replaceGroup: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      categoryTreeList: []
    }
  },

  computed: {
    treeCopyIds: {
      get() {
        return this.treeIds || this.treeIds === 0 ? this.treeIds : null
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  },

  created() {
    this.needInit && this.initData()
  },

  methods: {
    initData() {
      this.getCategoriesTreeData()
    },

    getCategoriesTreeData() {
      getSupplierLibSortApi()
        .then(res => {
          const list = (res.data || []).length
            ? res.data || []
            : [{ categoryId: 0, count: 0, name: '全部供应商', parentId: null }]

          const data = list.map(item => {
            if (this.disabledList.includes(item.categoryId)) {
              return {
                ...item,
                isDisabled: true
              }
            }
            return item
          })
          this.categoryTreeList = listTransformTree(data, 'categoryId')

          // 根节点-全部供应商
          const idx = this.categoryTreeList.findIndex(
            item => item.parentId === null
          )
          const rootIdx = idx === -1 ? 0 : idx

          const isHave = this.multiple
            ? this.treeIds.length
            : this.treeIds || this.treeIds === 0
          // 当前值treeIds为空&设置了默认选中第一个
          if (this.isCheckFirst && !isHave) {
            const obj = this.categoryTreeList[rootIdx]

            this.treeCopyIds = this.multiple
              ? this.valueFormat === 'id'
                ? [obj.categoryId]
                : [{ id: obj.categoryId, label: obj.name }]
              : this.valueFormat === 'id'
                ? obj.categoryId
                : { id: obj.categoryId, label: obj.name }
          }

          // TODO:
          // 这里为了不影响其他的使用地方单独使用
          // 这里设置更换分组使用的逻辑
          // 保证默认选中第一项（全部供应商）且设置其不可操作
          if (this.replaceGroup) {
            const obj = this.categoryTreeList[rootIdx]
            if (!this.treeCopyIds) this.treeCopyIds = []
            if (this.valueFormat === 'id') {
              if (!this.treeCopyIds.includes(obj.categoryId)) {
                this.treeCopyIds.push(obj.categoryId)
              }
            } else {
              if (
                this.treeCopyIds.findIndex(
                  value => value.id === obj.categoryId
                ) < 0
              ) {
                this.treeCopyIds.push({ id: obj.categoryId, label: obj.name })
              }
            }

            // 强制设置第一项不可更改
            this.categoryTreeList[rootIdx].isDisabled = true
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    // 数据转换
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.categoryId,
        label: node.name,
        children: node.children
      }
    }
  }
}
</script>
